document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('birthday-form');
    
    form.addEventListener('submit', function (e) {
        e.preventDefault(); // Evita il ricaricamento della pagina

        // Raccogli i dati del modulo
        const firstName = document.getElementById('first-name').value;
        const lastName = document.getElementById('last-name').value;
        const email = document.getElementById('email').value;
        const birthdate = document.getElementById('birthdate').value;

        // Controlla che i campi siano compilati
        if (!firstName || !lastName || !email || !birthdate) {
            alert('Per favore, compila tutti i campi!');
            return;
        }

        // Simula l'invio dei dati al server (puoi sostituire con un'API reale)
        console.log({
            Nome: firstName,
            Cognome: lastName,
            Email: email,
            'Data di nascita': birthdate,
        });

        alert(`Grazie, ${firstName}! Riceverai uno sconto il giorno del tuo compleanno!`);

        // Resetta il modulo
        form.reset();
    });
});
